<template>
  <div :style="scaleStyle" class="progress-wrapper">
    <div v-show="isProgress">
      <img :src="getIconUrl" :style="iconStyle" alt="" class="image-icon" />
      <div :style="progressStyle" class="progress">
        <div class="progress-bar__box">
          <div
            :style="{ width: progressBarSize.width + 'px', height: progressBarSize.height + 'px' }"
            class="progress-bar-default">
            <div v-if="isShowCheck" class="progress-bar-default__check"></div>
          </div>
          <div :style="getStyleActiveWrapper" class="progress-bar-active__wrapper">
            <div :style="getActiveWidth" class="progress-bar-active"></div>
          </div>
        </div>
        <span ref="progressText" :style="textStyle" class="progress-text"></span>
      </div>
    </div>
    <FreeSpinProgress v-show="!isProgress" />
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { mapGetters } from 'vuex';
import FreeSpinProgress from '@/components/progress/FreeSpinProgress.vue';

type style = {
  transform: string;
  top?: string;
  bottom?: string;
  left?: string;
  width: string;
  height: string;
  paddingTop: string;
  paddingLeft?: string;
  paddingRight?: string;
  right?: string;
};

export default Vue.extend({
  name: 'ProgressBar',
  components: { FreeSpinProgress },
  props: {
    isProgress: Boolean,
    getCurrentStep: [String, Number],
    getTotalStep: [String, Number],
    isShowCheck: {
      type: Boolean,
      default: false
    },
    styleCheck: {
      type: Object,
      default: () => ({
        leftCheck: 0,
        rightCheck: 0,
        topCheck: 0,
        scaleCheck: 1
      })
    },
    type: {
      type: String,
      default: 'achievement'
    }
  },
  mounted() {
    this.fontSize();
  },
  data: () => ({
    wrapperSize: {
      width: 400,
      height: 60
    },
    progressBarSize: {
      width: 170,
      height: 10,
      top: 25
    },
    maxFontSize: 25,
    maxWidthText: 150,
    sizeWrapper: {
      height: 60,
      width: 400
    }
  }),
  methods: {
    fontSize(): void {
      let fontSize = this.maxFontSize;
      const text = <HTMLSpanElement>this.$refs.progressText;
      text.textContent = `${this.getCurrentStep} / ${this.getTotalStep}`;
      text.style.fontSize = fontSize + 'px';
      while (text.scrollWidth > this.maxWidthText) {
        fontSize--;
        text.style.fontSize = fontSize + 'px';
      }
    }
  },
  watch: {
    getCurrentStep: function (): void {
      setTimeout(this.fontSize, 0);
    },
    getTotalStep: function (): void {
      setTimeout(this.fontSize, 0);
    },
    isProgress: function (): void {
      setTimeout(this.fontSize, 0);
    }
  },
  computed: {
    ...mapGetters(['getAppConfiguration', 'getIsMobile', 'isLandscape', 'getCanvasPosition', 'getUiPosition']),
    scaleStyle(): style {
      const addScale: number = this.getIsMobile ? 1.3 : 1;
      const left: number = this.wrapperSize.width / 2 + (this.getIsMobile && this.isLandscape ? 20 : 10);
      const scale: number = addScale * this.uiScale;
      let style: style = {
        transform: 'translate(-50%, -50%) scale(' + scale + ')',
        width: this.wrapperSize.width + 'px',
        height: this.wrapperSize.height + 'px',
        paddingTop: (this.isProgress ? this.progressBarSize.top : 0) + 'px'
      };

      // проверяем должно быть слева или справа
      if (this.isRightPosition) {
        const right: number =
          (this.isLandscape
            ? this.getUiPosition.landscape.progress.right
            : this.getUiPosition.portrait.progress.right) + this.styleCheck.rightCheck;
        style.right =
          right * scale -
          this.wrapperSize.width +
          (this.wrapperSize.width * scale) / 2 +
          this.getCanvasPosition.left +
          'px';
        style.paddingRight = 75 + 'px';
      } else {
        style.paddingLeft = (this.isProgress ? 70 : 4) + 'px';
        style.left = this.styleCheck.leftCheck * scale + left * scale + this.getCanvasPosition.left + 'px';
      }

      //проверяем должен ли находиться внизу или вверху
      if (!this.isLandscape && this.getUiPosition.portrait.progress.bottom) {
        style.bottom =
          this.getUiPosition.portrait.progress.bottom * scale * this.getAppConfiguration.devicePixelRatio +
          this.getCanvasPosition.top -
          (this.sizeWrapper.height - this.sizeWrapper.height * scale) +
          'px';
      } else {
        style.top =
          this.styleCheck.topCheck * scale +
          (40 + (this.isLandscape ? (this.getIsMobile ? 10 : 0) : this.getUiPosition.portrait.progress.top)) *
            this.uiScale +
          this.getCanvasPosition.top +
          'px';
      }

      return style;
    },
    uiScale(): number {
      return this.getAppConfiguration.scale * this.styleCheck.scaleCheck;
    },
    progressStyle(): any {
      return {
        flexDirection: this.isRightPosition ? 'row-reverse' : 'row'
      };
    },
    iconStyle(): any {
      const style: any = {};
      if (this.isRightPosition) {
        style.right = 0 + 'px';
      } else style.left = -8 + 'px';

      switch (this.type) {
        case 'freeBets':
          style.width = 55 + 'px';
          style.right = 15 + 'px';
          style.top = 2 + 'px';
      }
      return style;
    },
    textStyle(): any {
      const style: any = {};
      if (this.isRightPosition) {
        style.paddingRight = 5 + 'px';
      } else {
        style.paddingLeft = 5 + 'px';
      }
      return style;
    },
    isRightPosition(): boolean {
      const rightPortrait: number = this.getUiPosition.portrait.progress.right;
      const rightLandscape: number = this.getUiPosition.landscape.progress.right;
      return (rightPortrait && !this.isLandscape) || (rightLandscape && this.isLandscape) || this.styleCheck.rightCheck;
    },
    getIconUrl(): string {
      switch (this.type) {
        case 'freeBets':
          return `${__PROMO_CONFIG.STATIC_URL}/assets/img/progress/freeBets_icon.png`;
        default:
          return `${__PROMO_CONFIG.STATIC_URL}/assets/img/progress/achievements_icon.png`;
      }
    },
    getActiveWidth(): any {
      return {
        width: this.progressBarSize.width + 'px',
        height: this.progressBarSize.height + 'px',
        left:
          this.progressBarSize.width -
          (Number(this.getCurrentStep) / Number(this.getTotalStep)) * this.progressBarSize.width +
          'px'
      };
    },
    getStyleActiveWrapper(): any {
      // (Number(this.getCurrentStep) / Number(this.getTotalStep)) * this.progressBarSize.width
      return {
        width: this.progressBarSize.width + 'px',
        height: this.progressBarSize.height + 'px',
        top: 0 + 'px',
        left:
          -this.progressBarSize.width +
          (Number(this.getCurrentStep) / Number(this.getTotalStep)) * this.progressBarSize.width +
          'px'
      };
    }
  }
});
</script>

<style scoped>
.progress-wrapper {
  position: fixed;
  background-color: rgba(0, 0, 0, 0.6);
  border-radius: 30px;
}

.image-icon {
  transform: scale(0.8);
  position: absolute;
  top: -12px;
}

.progress {
  display: flex;
  align-items: center;
}

.progress-bar-default {
  background-color: #b2b2b2;
  border-radius: 10px;
  position: relative;
}

.progress-bar-default__check {
  position: absolute;
}

.progress-bar-default__check {
  right: 0;
  top: -16px;
  position: absolute;
  display: inline-block;
  width: 40px;
  height: 40px;
  background-color: rgba(18, 255, 0, 0.94);
  border-radius: 50%;
  z-index: 1;
}

.progress-bar-default__check::before {
  position: absolute;
  left: 6px;
  top: 49%;
  height: 40%;
  width: 8px;
  background-color: white;
  content: '';
  transform: translateX(10px) rotate(-45deg);
  transform-origin: left bottom;
}

.progress-bar-default__check::after {
  position: absolute;
  left: 7px;
  bottom: 4px;
  height: 8px;
  width: 71%;
  background-color: white;
  content: '';
  transform: translateX(10px) rotate(-45deg);
  transform-origin: left bottom;
}

.progress-bar__box {
  position: relative;
}

.progress-bar-active__wrapper {
  border-radius: 10px;
  position: absolute;
  overflow: hidden;
}

.progress-bar-active {
  position: absolute;
  background-color: #ffffff;
  border-radius: 10px;
}

.progress-text {
  color: #fff;
  font-weight: bold;
  line-height: 0;
}
</style>
